// Mock data for the Stan-style creator store clone (frontend-only)
// Targeted at high-ticket coaches & creators.

export const creator = {
  username: 'aria.mercer',
  name: 'Aria Mercer',
  tagline: 'Business & Monetization Coach',
  bio: 'I help 6-figure creators productize their expertise and scale to 7 figures. Book a call, grab a workbook, or join the masterclass. 💎',
  avatar: 'https://images.pexels.com/photos/8172091/pexels-photo-8172091.jpeg',
  verified: true,
  followers: '284K',
  rating: 4.9,
  reviews: 1270,
  socials: [
    { platform: 'instagram', handle: '@aria.mercer', url: '#' },
    { platform: 'youtube', handle: 'Aria Mercer', url: '#' },
    { platform: 'tiktok', handle: '@ariamercer', url: '#' },
    { platform: 'twitter', handle: '@ariamercer', url: '#' },
  ],
};

export const products = [
  {
    id: 'p1',
    type: 'Coaching Call',
    title: '1-on-1 Growth Audit Call',
    subtitle: '60-min private strategy session',
    description: 'A deep-dive private call where we audit your offer, funnel, and pricing, then build a 90-day action plan to scale your revenue.',
    price: 150,
    compareAt: 250,
    image: 'https://images.unsplash.com/photo-1526570207772-784d36084510',
    badge: 'Best Seller',
    sales: 842,
    rating: 5.0,
    highlights: ['Live 60-min Zoom call', 'Personalized 90-day plan', 'Recording + notes included', 'Follow-up email support'],
  },
  {
    id: 'p2',
    type: 'Masterclass',
    title: 'The 7-Figure Offer Masterclass',
    subtitle: 'Self-paced video course',
    description: '4 hours of on-demand training that walks you through crafting, pricing, and launching a high-ticket offer that sells while you sleep.',
    price: 299,
    compareAt: 499,
    image: 'https://images.unsplash.com/photo-1542983396-d903783bb96b',
    badge: 'Most Popular',
    sales: 2310,
    rating: 4.9,
    highlights: ['4+ hours of HD lessons', '12 fill-in-the-blank templates', 'Private community access', 'Lifetime updates'],
  },
  {
    id: 'p3',
    type: 'Workbook',
    title: 'The Strategy Workbook',
    subtitle: 'Digital PDF download',
    description: 'A 48-page interactive workbook with the exact frameworks I use to plan launches and map customer journeys.',
    price: 49,
    compareAt: 79,
    image: 'https://images.unsplash.com/photo-1560298468-fce7a2765ddd',
    badge: null,
    sales: 5120,
    rating: 4.8,
    highlights: ['48-page fillable PDF', '9 proven frameworks', 'Notion version included', 'Instant download'],
  },
  {
    id: 'p4',
    type: 'Bundle',
    title: 'Creator Launch Toolkit',
    subtitle: 'Templates + swipe files',
    description: 'Everything you need to launch: email sequences, sales page copy, content calendars and ad templates.',
    price: 129,
    compareAt: 210,
    image: 'https://images.unsplash.com/photo-1461749280684-dccba630e2f6',
    badge: 'Bundle',
    sales: 1640,
    rating: 4.9,
    highlights: ['30+ Canva templates', '6 email sequences', 'Sales page swipe files', 'Content calendar'],
  },
  {
    id: 'p5',
    type: 'Membership',
    title: 'Inner Circle Membership',
    subtitle: 'Monthly coaching community',
    description: 'Weekly group coaching calls, hot-seat feedback and a private community of ambitious creators.',
    price: 97,
    compareAt: null,
    image: 'https://images.pexels.com/photos/3202032/pexels-photo-3202032.jpeg',
    badge: 'Subscription',
    sales: 410,
    rating: 5.0,
    highlights: ['Weekly group calls', 'Private community', 'Monthly guest experts', 'Cancel anytime'],
  },
  {
    id: 'p6',
    type: 'Ebook',
    title: 'Content-to-Cash Playbook',
    subtitle: 'Digital PDF download',
    description: 'The exact content system that turns free followers into paying clients across every platform.',
    price: 39,
    compareAt: 59,
    image: 'https://images.unsplash.com/photo-1507721999472-8ed4421c4af2',
    badge: null,
    sales: 3980,
    rating: 4.7,
    highlights: ['90-page playbook', '30 viral hook formulas', 'Posting calendar', 'Instant download'],
  },
];

// Interactive Funnel Blocks
export const flashDrop = {
  title: 'Flash Drop: Black Label Intensive',
  subtitle: 'A private 90-min deep dive. Only 5 seats.',
  price: 450,
  compareAt: 750,
  seatsLeft: 3,
  endsInSeconds: 60 * 60 * 6, // 6 hours
};

export const quiz = {
  title: 'Find Your Custom Coaching Tier',
  subtitle: '2 quick questions — get a personalized recommendation.',
  questions: [
    {
      id: 'q1',
      prompt: 'Where are you in your journey?',
      options: [
        { label: 'Just getting started', value: 'start' },
        { label: 'Making some sales, want more', value: 'grow' },
        { label: 'Established, ready to scale', value: 'scale' },
      ],
    },
    {
      id: 'q2',
      prompt: 'How hands-on do you want the help?',
      options: [
        { label: 'Do-it-myself resources', value: 'diy' },
        { label: 'A structured program', value: 'program' },
        { label: 'Personal 1-on-1 guidance', value: 'personal' },
      ],
    },
  ],
  // recommendation returns an index into the products array
  recommend: (a, b) => {
    if (b === 'personal') return 0; // 1-on-1 call
    if (b === 'program' || a === 'grow') return 1; // masterclass
    if (a === 'start' || b === 'diy') return 2; // workbook
    return 3; // bundle
  },
};

// AI Concierge canned/rule-based responses (MOCKED)
export const conciergeConfig = {
  greeting: `Hi! I'm Aria's AI concierge 💎 I can help you pick the right offer, answer questions, or handle any hesitations. What are you hoping to achieve?`,
  quickReplies: [
    'Is the $150 call worth it?',
    'Which product should I start with?',
    'What if it doesn\'t work for me?',
    'Do you offer refunds?',
  ],
};

// Dashboard mock data
export const salesStats = {
  revenueToday: 1840,
  revenue30d: 42680,
  revenueTotal: 318420,
  orders30d: 214,
  conversion: 6.4,
  visitors30d: 8420,
  aov: 199,
  aiInquiries: 1284,
};

export const revenueSeries = [
  { day: 'Mon', value: 4200 }, { day: 'Tue', value: 5100 }, { day: 'Wed', value: 3800 },
  { day: 'Thu', value: 6400 }, { day: 'Fri', value: 7200 }, { day: 'Sat', value: 5900 }, { day: 'Sun', value: 6900 },
];

export const recentOrders = [
  { id: 'o1', buyer: 'Jordan R.', product: 'The 7-Figure Offer Masterclass', amount: 299, time: '2m ago', avatar: 'https://i.pravatar.cc/80?img=12' },
  { id: 'o2', buyer: 'Priya S.', product: '1-on-1 Growth Audit Call', amount: 150, time: '18m ago', avatar: 'https://i.pravatar.cc/80?img=45' },
  { id: 'o3', buyer: 'Marcus L.', product: 'The Strategy Workbook', amount: 49, time: '41m ago', avatar: 'https://i.pravatar.cc/80?img=33' },
  { id: 'o4', buyer: 'Elena V.', product: 'Creator Launch Toolkit', amount: 129, time: '1h ago', avatar: 'https://i.pravatar.cc/80?img=25' },
  { id: 'o5', buyer: 'Tom H.', product: 'Inner Circle Membership', amount: 97, time: '2h ago', avatar: 'https://i.pravatar.cc/80?img=52' },
  { id: 'o6', buyer: 'Aisha K.', product: 'Content-to-Cash Playbook', amount: 39, time: '3h ago', avatar: 'https://i.pravatar.cc/80?img=9' },
];

// Billing & Subscriptions (Dashboard)
export const billing = {
  currentTier: 'free', // 'free' | 'pro'
  tiers: [
    {
      id: 'free',
      name: 'Free',
      price: 0,
      fee: '9% transaction fee',
      tagline: 'Get started at no cost',
      features: [
        'Unlimited products & links',
        'Storefront builder',
        '1-tap checkout',
        'Basic analytics',
      ],
      locked: ['AI Sales Concierge', 'Interactive Funnel Blocks', 'Priority support'],
    },
    {
      id: 'pro',
      name: 'Pro',
      price: 39,
      fee: '0% transaction fees',
      tagline: 'For serious high-ticket creators',
      features: [
        'Everything in Free',
        '0% transaction fees',
        'AI Sales Concierge',
        'Interactive Funnel Blocks',
        'Advanced analytics & funnels',
        'Priority support',
      ],
      locked: [],
    },
  ],
  invoices: [
    { id: 'inv1', date: 'Jun 01, 2025', amount: 39, status: 'Paid', plan: 'Pro Monthly' },
    { id: 'inv2', date: 'May 01, 2025', amount: 39, status: 'Paid', plan: 'Pro Monthly' },
    { id: 'inv3', date: 'Apr 01, 2025', amount: 39, status: 'Paid', plan: 'Pro Monthly' },
  ],
  nextBilling: 'Jul 01, 2025',
  paymentMethod: { brand: 'Visa', last4: '4242', exp: '08/27' },
};

export const testimonials = [
  { name: 'Jenna M.', role: 'Fitness Coach', text: 'The audit call alone paid for itself 10x. Aria helped me repackage my program and I hit $22k the next month.', avatar: 'https://i.pravatar.cc/80?img=47' },
  { name: 'David O.', role: 'Agency Owner', text: 'The masterclass is worth 5x the price. Clear, actionable, no fluff. My close rate doubled.', avatar: 'https://i.pravatar.cc/80?img=15' },
  { name: 'Sofia R.', role: 'Course Creator', text: 'I was skeptical about high-ticket but the workbook made the whole thing click. Best $49 I have spent.', avatar: 'https://i.pravatar.cc/80?img=31' },
];

// AI Concierge template presets (Dashboard settings)
export const conciergePresets = [
  {
    id: 'objection',
    name: 'Objection Handler',
    description: 'Neutralizes pre-purchase hesitations for high-value offers.',
    prompt: `You are the AI Sales Concierge for [Creator Name], a high-ticket coach.
Your #1 job is to calmly handle objections about [Product Name] ($[Price]).
When a visitor hesitates on price, reframe it around [Key Benefit] and ROI.
Always mention the 14-day money-back guarantee to remove risk.
Keep replies warm, confident, and under 3 sentences. End by inviting the next step.`,
  },
  {
    id: 'qualifier',
    name: 'Lead Qualifier',
    description: 'Asks smart questions to match visitors to the right offer.',
    prompt: `You are the AI Sales Concierge for [Creator Name].
Qualify each visitor by asking about their goals, stage, and budget.
Recommend the best fit between [Product Name] ($[Price]) and other offers.
Politely capture their email to send a personalized recommendation.
Focus on [Key Benefit]. Be curious and consultative, never pushy.`,
  },
  {
    id: 'closer',
    name: 'Sales Closer',
    description: 'Drives urgency and guides visitors to complete checkout.',
    prompt: `You are the AI Sales Concierge for [Creator Name], focused on closing.
Guide the visitor confidently toward purchasing [Product Name] ($[Price]).
Emphasize [Key Benefit], limited availability, and the outcome they'll get.
Create gentle urgency and always provide a direct checkout link.
Keep it punchy, positive, and action-oriented.`,
  },
];

// Payouts & Settings (Dashboard)
export const payouts = {
  connected: true,
  provider: 'Stripe Connect',
  returnUrl: 'https://biocloser.com/dashboard?stripe=connected',
  refreshUrl: 'https://biocloser.com/dashboard?stripe=refresh',
  balanceUSD: 3240,
  pendingUSD: 890,
  payoutCurrency: 'NOK',
  fxRate: 10.6, // 1 USD -> NOK (mock)
  nextPayout: 'Jul 05, 2025',
  bank: { name: 'DNB Bank', last4: '8891', country: 'Norway' },
  history: [
    { id: 'pay1', date: 'Jun 21, 2025', usd: 2480, nok: 26288, status: 'Paid' },
    { id: 'pay2', date: 'Jun 14, 2025', usd: 1920, nok: 20352, status: 'Paid' },
    { id: 'pay3', date: 'Jun 07, 2025', usd: 3110, nok: 32966, status: 'Paid' },
  ],
};

// Social Growth & Auto-DM (Dashboard)
export const autoDM = {
  enabled: true,
  triggerKeyword: 'AI',
  platforms: { instagram: true, tiktok: true },
  templates: [
    { id: 'dm1', name: 'Freebie Delivery', text: `Hey! Thanks for commenting 🙌 Here's the free [Key Benefit] resource I promised: [Link]. Reply if you have any questions!` },
    { id: 'dm2', name: 'Soft Pitch', text: `So glad this resonated! If you want the full system, my [Product Name] ($[Price]) walks you through it step-by-step 👉 [Link]` },
    { id: 'dm3', name: 'Waitlist Invite', text: `Doors for [Product Name] open soon 👀 Want me to save you a spot on the early-bird list? Just reply YES.` },
    { id: 'dm4', name: 'Call Booking', text: `Would love to help you 1-on-1! Grab a spot for a [Product Name] here: [Link]. Limited slots this week 🗓️` },
    { id: 'dm5', name: 'Objection Buster', text: `Totally get the hesitation! [Product Name] is backed by a 14-day guarantee, so it's zero risk. Want the details? 💬` },
  ],
  stats: {
    commentsTriggered: 4820,
    dmsSent: 4610,
    conversionRate: 8.7,
  },
};
